<template>
  <div id="edit-location" class="container">
    <loading-indicator :loading="loading"></loading-indicator>
    <div v-if="!loading">
      <div class="row">
        <div class="col-12">
          <notification
            id="edit-location-error-msg"
            v-if="error"
            @close="resetError()"
            :message="error"
            type="alert-danger"
          ></notification>
          <location-form
            successTitle="Save"
            cancelTitle="Cancel"
            :create="false"
            :location.sync="location"
            :successAction="saveLocation"
            :cancelAction="cancel"
          ></location-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoreAPI from "@/utils/core-api";
import * as modals from "@/utils/modals";
import LocationForm from "./LocationForm";
import Notification from "@/components/Notification";
import LoadingIndicator from "@/components/LoadingIndicator";

export default {
  name: "EditLocation",
  components: {
    LocationForm,
    Notification,
    LoadingIndicator
  },
  data() {
    return {
      loading: true,
      location: {},
      error: ""
    };
  },
  async created() {
    await this.fetchLocation(this.$route.params.ip);
  },
  methods: {
    cancel() {
      this.$router.push({ name: "Locations" });
    },
    resetError() {
      this.error = null;
    },
    async fetchLocation(ip) {
      try {
        this.loading = true;
        this.location = await CoreAPI.getLocation(ip);
      } catch (error) {
        this.error = "Failed to load location";

        if (error.isNetworkError) {
          await modals.showLostConnectionModal(this.$bvModal);
        }
      } finally {
        this.loading = false;
      }
    },
    async saveLocation() {
      try {
        await CoreAPI.updateLocation(this.location);
        this.$router.push({ name: "Locations" });
      } catch (error) {
        this.error = "Failed to save location";

        if (error.isNetworkError) {
          await modals.showLostConnectionModal(this.$bvModal);
        }
      }
    }
  }
};
</script>
